module.exports = __webpack_public_path__ + "banquet/components/Download/images/phones_2x.c97f3a8c14d5c651e0cea6659c6aae3a.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Download/images/phones_2x.png
// module id = 1662
// module chunks = 1